import graphql from './graphql';

const query = /* GraphQL */ `
  query Course_findByName($name: String!, $category: String, $author: String, $terminal: String, $isDraft: Boolean) {
    Course_findByName(category: $category, name: $name, author: $author, terminal: $terminal, isDraft: $isDraft) {
      id
      name
      description
      expirationDate
      updatedAt
      thumbnail
      isDraft
      Priority {
        name
        id
      }
      CourseCategory {
        name
        id
      }
      User {
        fullName
        photo
      }
    }
  }
`;

const CourseFindByName = async ({ category = null, name = '', author = null, terminal = null, isDraft = null }) =>
  graphql(query, { category, name, author, terminal, isDraft }).then(
    // eslint-disable-next-line camelcase
    ({ Course_findByName }) => Course_findByName
  );

export default CourseFindByName;
